<div class="flex flex-col gap-y-6">
  <div class="flex items-center justify-between">
    <div>
      <app-page-headline
        [headline]="'pages.snapshotDetail.headline' | translate"
        [isLoading]="isLoading"
        [count]="total"
      />
    </div>
    <div class="flex gap-2">
      <app-back-button />
      <app-button
        data-test-id="downloadButton"
        type="primary"
        (trigger)="download()"
      >
        <svg-icon class="size-5" src="assets/icons/General/download-01.svg" />
        {{ 'pages.snapshotDetail.downloadButton' | translate }}
      </app-button>
    </div>
  </div>

  <div class="space-y-1 rounded-xl bg-grey-50 px-4 py-3">
    @if (snapshot) {
      <div
        data-test-id="snapshotMetaData"
        class="flex justify-between gap-4 text-lg"
      >
        <span class="">
          {{ 'models.snapshot.createdBy.label' | translate }}:
          <a
            data-test-id="snapshotCreatedBy"
            class="underline"
            [href]="`mailto:${snapshot.createdBy}`"
            >{{ snapshot.createdBy }}</a
          >
        </span>
        <span data-test-id="snapshotCreatedAt" class="">{{
          snapshot.createdAt | date: 'dd.MM.yyyy - HH:mm:ss'
        }}</span>
      </div>

      <div>
        <span
          data-test-id="snapshotName"
          class="after:mx-2 after:content-['•']"
        >
          {{ 'models.snapshot.name.label' | translate }}:
          {{ snapshot.name }}
        </span>
        <span data-test-id="snapshotNote">
          {{ 'models.snapshot.note.label' | translate }}:
          {{ snapshot.note }}
        </span>
      </div>
      @for (filter of snapshotFilters; track filter) {
        <div data-test-id="snapshotFilters" class="text-sm text-grey-500">
          {{ filter }}
        </div>
      }
    } @else {
      <nz-skeleton
        data-test-id="skeleton"
        [nzParagraph]="{ rows: 2 }"
        [nzActive]="true"
      />
    }
  </div>

  <div class="flex flex-col gap-6">
    <app-search-box
      data-test-id="searchBox"
      class="w-80"
      [isLoading]="isLoading"
      (changeSearch)="onSearchFilterChange($event)"
    />

    <app-master-addresses
      data-test-id="masterAddresses"
      [tableData]="tableData"
      [sword]="sword"
      [total]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [isLoading]="isLoading"
      [defaultSorting]="activeSorting"
      (changeHandler)="changeTableHandler($event)"
    />
  </div>
</div>
